import { render, staticRenderFns } from "./bo-login.vue?vue&type=template&id=ccf1c9e0"
import script from "./bo-login.vue?vue&type=script&lang=js"
export * from "./bo-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports